var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs_content baseInfo"},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"item-key":"id","headers":_vm.transHeader,"items":_vm.transList,"loading":_vm.loading2,"items-per-page":20,"footer-props":{
            itemsPerPageAllText: '全部',
            itemsPerPageText: '每页',
            showCurrentPage: true,
            itemsPerPageOptions: [5,10,15,20,-1],
        }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }